export default __webpack_public_path__ + "static/media/expand-white.05484948.svg";